export const headerSearchStyles = {
  root: 'relative block min-w-0 w-full',
  form: 'flex min-w-0 w-full items-center gap-1',
  inputWrap: 'relative min-w-0 w-full',
  input:
    'h-10 min-w-0 w-full rounded-md border border-border-subtle bg-bg-canvas px-3 pr-9 text-base text-fg-primary placeholder:text-fg-muted focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/30 transition-base min-[1274px]:h-9 min-[1274px]:text-sm',
  inputIcon: 'absolute right-2 top-1/2 -translate-y-1/2 text-fg-muted',
  iconGlyph: 'h-4 w-4',
  panel:
    'animate-overlay-in absolute left-0 top-full z-overlay mt-2 max-h-[min(70vh,42rem)] w-full overflow-y-auto rounded-xl border border-border-subtle bg-bg-canvas ring-1 ring-black/5 shadow-[0_24px_60px_-15px_rgba(0,0,0,0.35),0_8px_18px_-8px_rgba(0,0,0,0.25)] min-[1274px]:left-1/2 min-[1274px]:w-[min(44rem,calc(100vw-2rem))] min-[1274px]:-translate-x-1/2',
  panelEmpty: 'p-3 text-sm text-fg-muted',
  historyHeader:
    'flex items-center justify-between gap-3 border-b border-border-subtle px-4 py-3 text-xs font-semibold text-fg-secondary',
  historyClear:
    'shrink-0 rounded px-1 py-0.5 text-xs font-medium text-accent transition-colors hover:text-accent-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent',
  historyItem:
    'flex w-full items-center gap-3 px-4 py-3 text-left text-sm text-fg-primary transition-colors hover:bg-bg-subtle focus:bg-bg-subtle focus:outline-none',
  historyTerm: 'min-w-0 flex-1 truncate',
  list: 'flex flex-col py-1',
  item: 'flex items-center gap-4 px-4 py-3 text-left text-sm text-fg-primary hover:bg-bg-subtle focus:bg-bg-subtle focus:outline-none',
  thumb:
    'h-16 w-16 flex-shrink-0 rounded-md border border-border-subtle bg-bg-subtle object-contain',
  itemBody: 'flex min-w-0 flex-1 flex-col',
  itemTitle: 'line-clamp-2 font-medium leading-snug text-fg-primary',
  itemBrand: 'mt-1 text-xs text-fg-muted',
  itemPrices: 'mt-1 flex flex-wrap items-baseline gap-x-2 gap-y-0.5',
  itemPrice: 'font-semibold text-fg-primary',
  itemOriginalPrice: 'text-xs text-fg-muted line-through',
  footer:
    'flex items-center justify-between border-t border-border-subtle px-3 py-2 text-xs text-accent hover:bg-bg-subtle',
  iconButtonMobile:
    'text-fg-secondary hover:text-fg-primary hover:bg-bg-subtle inline-flex h-11 w-11 items-center justify-center rounded-md transition-colors duration-fast ease-token md:hidden',
} as const;
